import {Component, Prop, Vue} from "vue-property-decorator";
import {Getter} from "vuex-class";
import {downloadStat, getStats} from "~/modules/stats/service";
import {Column} from "~/components/grid/column";
import {Columns} from "~/components/grid/columns";
import {formatDate} from "~/lib/helpers/formatters";
import {Loader} from "~/components/loader";
import {saveAs} from "file-saver";
import iconCsv from '~/assets/inline-svg/icon_csv.svg?inline';

@Component
export class StatsActions extends Vue {
  @Prop({required: true}) clientUUID: string;
  @Getter currentUser;

  private isLoading = false

  private stats: any[] = [];
  private statsTotal = 0;
  private pagination = {perPage: 50, currentOffset: 0};

  get headers() {
    return [
      {
        key: 'createdAt',
        value: stat => stat.created_at ? formatDate(stat.created_at) : "-",
        label: "Date",
        className: "is-narrow"
      },
      {
        key: 'type',
        value: stat => stat.type || "-",
        label: "Type"
      },
      {
        key: 'name',
        value: stat => stat.name || "-",
        label: "Nom"
      },
      {
        key: 'action',
        value: stat => stat.action || "-",
        label: "Action",
        className: "is-narrow"
      },
      {
        key: 'user',
        value: stat => stat.user || "-",
        label: "Utilisateur"
      },
      {
        key: 'description',
        value: stat => stat.description || "-",
        label: "Description"
      }
    ];
  }

  async created() {
    // await this.loadStats();
  }

  async loadStats() {
    this.isLoading = true;

    const {total, stats} = await getStats(this.currentUser.client, {
      pagination: this.pagination,
    });

    this.statsTotal = total;
    this.stats = stats;

    this.isLoading = false;
  }

  async paginate(toPage) {
    this.pagination.currentOffset = toPage - 1;
    await this.loadStats();
  }

  async onClickDownload(type: 'csv') {
    try {
      const data = await downloadStat(this.clientUUID);
      const file = new File([data], "report.csv", {type: "text/csv;charset=utf-8"});
      saveAs(file);
    } catch (err) {
      this.$notify.error("Téléchargement du fichier impossible. Veuillez contacter le support");
      console.error(err);
    }
  }

  render() {

    if (this.isLoading) {
      return <Loader/>;
    }

    return (
      <div class="stats">
        <Columns>
          <Column>
            <h2 class="page-subtitle">Exporter</h2>
            <div class={"export-buttons-container"}>
              <a class="button button-primary" onClick={() => this.onClickDownload('csv')} domPropsInnerHTML={iconCsv}/>
            </div>
          </Column>
        </Columns>
      </div>
    );
  }
}


// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-3723ce63/stats-actions.tsx" });